<template>
  <div class="usermanagement">
    <div class="content">
      <div class="title">
        <div>{{ $t('用户列表') }}</div>
        <div class="tool">
          <el-input
            v-model.trim="searchValue"
            style="width:220px;margin-right:20px"
            size="small"
            :placeholder="$t('请输入')"
            >
            <i slot="suffix" class="el-input__icon el-icon-search" @click="handleSearch(1)"></i>
          </el-input>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="goRoute('')">{{ $t('添加') }}</el-button>
        </div>
      </div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column :label="$t('序号')" type="index" width="100">
            <template slot-scope="scope">
              <span>{{(page-1)*10+scope.$index+1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" :label="$t('姓名')"/>
          <el-table-column prop="id" :label="$t('用户ID')"/>
          <el-table-column prop="phone" :label="$t('手机号')"/>
          <el-table-column prop="status" :label="$t('状态')">
            <template slot-scope="scope">
              <span :class="[!scope.row.status?'greenStatus':'redStatus']">{{!scope.row.status?$t('启用'):$t('禁用')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('创建时间')"/>
          <el-table-column :label="$t('操作')" width="120" align="center">
            <template slot-scope="scope">
              <img 
                src="@/assets/images/common/edit.png" 
                style="margin-right:20px"
                @click="goRoute(scope.row)"
              />
              <img src="@/assets/images/common/del.png"  @click="comfirm(scope.row)"/>
            </template>
          </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="page" :size.sync="size"  @getTableData="handleSearch"/>
    </div>
  </div>
</template>

<script>
const pagination = () => import('@/components/pagination.vue')
import { isComfirm } from '@/utils/utils.js'
import { getUserList,deleteUser } from '@/api/usermanagement'
export default {
  name: "usermanagement",
  components:{
    pagination
  },
  data() {
    return {
      tableData:[],
      total:0,
      page:1,
      size:10,
      searchValue:'',
    };
  },
  watch:{
    size(){
      this.handleSearch(1)
    }
  },
  activated(){
    this.handleSearch()
  },
  methods:{
    //查询
    handleSearch(page){
      page ? this.page = page : this.page = 1;
      let params = {
        current:this.page,
        size:this.size,
        name:this.searchValue
      }
      getUserList(params).then(res=>{
        if(res.code==200){
          this.tableData = res.data.records
          this.total = res.data.total
        }else{
          this.$message.error(res.msg || this.$t('接口失败'))
        }
      })
    },
    //二次确认
    comfirm(row){
      isComfirm(row,this.del)
    },
    //删除
    del(row){
      deleteUser(row.id).then(res=>{
        if(res.code==200){
          this.$message.success(this.$t('删除成功'))
          this.handleSearch(this.page)
        }else{
          this.$message.error(res.msg || this.$t('接口失败'))
        }
      })
    },
    goRoute(row){
      this.$router.push({
        path:'usermanagement_edit',
        query:row
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/element-reset.scss';
.usermanagement{
  padding:10px 20px;
  position: relative;
  height: calc(100vh - 140px);
  text-align: left;
  color: #E8E8E8;
  .content{
    position: relative;
    background: #232323;
    min-height: calc(100vh - 250px);
    text-align: left;
    padding: 25px 35px 80px 35px;
    .title{
      font-size: 20px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
    }
    img{
      width: 22px;
      height: 22px;
      cursor: pointer;
    }
    .tool{
      width: 300px;
      display: flex;
      align-items: center;
    }
  }
  .greenStatus{
    &::before{
      content: '●';
      color: #2DEB79;
      margin-right: 5px;
      font-size: 20px;
    }
  }
 .redStatus{
    &::before{
      content: '●';
      color: #EB2D2D;
      margin-right: 5px;
      font-size: 20px;
    }
  }
}
</style>
